import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">深度策划专题内容，带你走进事件背后的故事</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="group relative rounded-2xl overflow-hidden aspect-[3/4] sm:aspect-[4/5] lg:aspect-[3/4] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20magazine%20cover%20style%20image%20with%20warm%20red%20and%20gold%20gradients%2C%20showing%20abstract%20entertainment%20industry%20symbols%20like%20spotlight%20and%20stage%20elements%2C%20sophisticated%20dark%20background%20with%20warm%20accents&width=800&height=1000&seq=carousel-01&orientation=portrait"
              alt="黑料吃瓜在线 - 2026娱乐圈年中吃瓜报告"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/90 via-foreground-900/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-1 rounded bg-accent-500/80 text-background-50 text-[10px] font-medium mb-2 whitespace-nowrap">年度专题</span>
              <h3 className="font-heading text-base font-bold text-background-50 mb-1.5">2026娱乐圈年中吃瓜报告</h3>
              <p className="text-xs text-background-50/70 leading-relaxed">半年盘点：从塌房到逆袭，娱乐圈那些让人跌破眼镜的瞬间。</p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[3/4] sm:aspect-[4/5] lg:aspect-[3/4] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20photography%20style%20image%20of%20a%20shopping%20cart%20with%20digital%20screens%20floating%20around%20it%2C%20warm%20orange%20and%20amber%20lighting%2C%20conceptual%20ecommerce%20theme%2C%20clean%20dark%20background&width=800&height=1000&seq=carousel-02&orientation=portrait"
              alt="黑料吃瓜在线 - 直播带货从风口到翻车"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/90 via-foreground-900/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-1 rounded bg-accent-500/80 text-background-50 text-[10px] font-medium mb-2 whitespace-nowrap">深度调查</span>
              <h3 className="font-heading text-base font-bold text-background-50 mb-1.5">直播带货：从风口到翻车</h3>
              <p className="text-xs text-background-50/70 leading-relaxed">深度调查直播带货行业乱象，消费者权益如何保障？</p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[3/4] sm:aspect-[4/5] lg:aspect-[3/4] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=An%20editorial%20style%20image%20showing%20abstract%20network%20connections%20with%20glowing%20warm%20nodes%2C%20representing%20social%20media%20influence%2C%20golden%20and%20amber%20tones%2C%20dark%20sophisticated%20background&width=800&height=1000&seq=carousel-03&orientation=portrait"
              alt="黑料吃瓜在线 - 网红产业链大揭秘"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/90 via-foreground-900/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-1 rounded bg-accent-500/80 text-background-50 text-[10px] font-medium mb-2 whitespace-nowrap">产业观察</span>
              <h3 className="font-heading text-base font-bold text-background-50 mb-1.5">网红产业链大揭秘</h3>
              <p className="text-xs text-background-50/70 leading-relaxed">从素人到顶流，揭秘网红背后的资本运作与流量密码。</p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[3/4] sm:aspect-[4/5] lg:aspect-[3/4] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=A%20conceptual%20editorial%20image%20showing%20a%20magnifying%20glass%20over%20digital%20text%20and%20symbols%2C%20representing%20fact-checking%20and%20truth%20seeking%2C%20warm%20amber%20lighting%2C%20dark%20sophisticated%20background&width=800&height=1000&seq=carousel-04&orientation=portrait"
              alt="黑料吃瓜在线 - 社交媒体时代的真相与谣言"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/90 via-foreground-900/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-1 rounded bg-accent-500/80 text-background-50 text-[10px] font-medium mb-2 whitespace-nowrap">特别企划</span>
              <h3 className="font-heading text-base font-bold text-background-50 mb-1.5">社交媒体时代的真相与谣言</h3>
              <p className="text-xs text-background-50/70 leading-relaxed">在信息爆炸的时代，如何辨别真假瓜？</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}